import React, {Component} from 'react';

// 活动信息组件，活动报名和显示活动详情使用
export default class CustomImg extends Component {

  render() {
    let {extra, src, params, className = '', imgProps} = this.props;
    return (
      <div className={`custom-img ${className}`}>
        <img alt="" src={`${src}${params}`} {...imgProps} />
        {extra ? extra : null}
      </div>
    );
  }

  static defaultProps = {
    params: '?x-oss-process=image/resize,m_lfit,h_100,w_100',
  };
}
